import { ILabel } from './interfaces';

export const fieldTypes = {
  break: 'break',
  childRowList: 'child_row_list',
  currency: 'currency',
  date: 'date',
  decimal: 'decimal',
  dropdown: 'dropdown',
  float: 'float',
  information: 'information',
  integer: 'integer',
  label: 'label',
  multiple: 'multiple',
  percentage: 'percentage',
  sum: 'sum',
  summation: 'summation',
  table: 'table',
  text: 'text',
  textArea: 'text_area',
  warning: 'warning',
  yesOrNo: 'yes_no',
};

export interface IFieldProps {
  stateKey: number;
  label: string;
  type: string;
  required: boolean;
  options?: Array<{ value: string; label: string }>;
  children?: ILabel[];
}

export interface SearchOptions {
  searchText: string;
  selectedRequestType: number;
  selectedTimePeriod: number;
}

export const IDLE_TIMEOUT_MS = 8 * 60 * 60 * 1000; // 8 hours
export const IDLE_MODAL_COUNTDOWN_SECONDS = 119; // 119 seconds (just under 2 minutes)

/** Synthetic label id: "Other" line-item descriptions (Property Preservation); see useRequestFormSubmit. */
export const OTHER_LINE_ITEM_DESCRIPTION_LABEL_ID = 999;

/** Label id for Servicer Account Id field on request forms. */
export const ACCOUNT_ID_LABEL_ID = 2;

/** Label id for Property Address dropdown on Property Preservation requests. */
export const PROPERTY_ADDRESS_LABEL_ID = 308;

/** Submitted value when no property addresses exist for the account. */
export const PROPERTY_ADDRESS_NOT_APPLICABLE_VALUE = 'Not Applicable';

/** Minimum accepted date for editable date fields (ISO format). */
export const MIN_ACCEPTED_DATE = '2000-01-01';
